import { getEnvValue } from './utils';

const apiHost = getEnvValue('NEXT_PUBLIC_API_HOST');
const apiEndpoint = `https://${apiHost}`;

const socketEndpoint = apiHost ? `wss://${apiHost}` : undefined;

const api = Object.freeze({
  host: apiHost,
  endpoint: apiEndpoint,
  socket: socketEndpoint,
  basePath: '',
});

export default api;
